import { createContext, useContext } from 'react'
import { IShopServices } from '@core/config/services'

// Typing: Need to make sure that default value is overridden in provider
export const ServiceContext = createContext<IShopServices>({} as any)

export const useServices = () => {
  return useContext(ServiceContext)
}
